export const formatDate = (date) => date.replace(/-/g, '.').slice(0, 10);
